import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { setlocal } from '@src/utils/index';

const Success = ({ updateId }) => {
    const tipText = updateId ? '导演组已经收到你更新的资料啦！' : '导演组已经收到你的资料啦！';
    const successText = window.allData?.
        modules[3]?.data?.articleList[0]?.summary || '我们会飞快查看并第一时间联系您哦~';
    const contactText = window.allData?.
        modules[3]?.data?.articleList[1]?.summary || '问题反馈请微信联系：<span>Ifeng-YOUTHBANG</span>';

    useEffect(() => {
        setlocal('img1FormBase64Url', null);
        setlocal('img2FormBase64Url', null);
        setlocal('formData', null);
        // setlocal('submitSucess', 1);

        setTimeout(() => {
            location.href = location.href.includes('from_wecom=1') ? location.href : `${location.href}?from_wecom=1`;
        }, 8000);
    }, []);
    
    return (
        <div className={styles.success}>
            <div className={styles.successBox}>{tipText}<br />{successText}</div>
            <div className={styles.successCallback} dangerouslySetInnerHTML={{ __html: contactText }} />
        </div>
    );
};

Success.propTypes = {
    updateId: PropTypes.string,
};

export default errorBoundary(Success);
